<template>
  <v-layout column>
    <v-card class="mx-2 pb-2 intro-dark align-center justify-center">
      <v-card-title class="py-3 justify-center prompt-header">
        <mrx-translation :token="updatedPrompt"></mrx-translation>
      </v-card-title>

      <v-card-text class="pb-0">
        <multiselect
          v-model="locations"
          panelName="location"
          panelType="select"
          languagePath="locations"
          :sortAlphabetical=true
          :onClick="handleSelect"
          >
        </multiselect>

        <v-divider v-if="selectionPresent" />

      </v-card-text>

      <v-card-actions
        v-if="selectionPresent"
        class="py-5 justify-center"
      >
        <v-btn
          outlined
          id="reset-locations-button"
          class="reset-warning"
          @click="initialize"
        >
          <mrx-translation token="app.location.button.reset" />
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect'
  import { mapActions, mapState } from 'pinia'
  import { usePartnerConfigStore } from '@/stores/partnerConfig'
  import { useLocationStore } from '@/stores/location'

  export default {
    name: 'Location',
    components: {
      multiselect: MultiSelect,
    },
    data() {
      return {
        prompt: `questions.location.prompt`,
      }
    },
    computed: {
      updatedPrompt() {
        const suffix = this.locations[0]?.type || 'location';

        return `${this.prompt}.${suffix}`;
      },
      selectionPresent() {
        return !!this.current
      },
      ...mapState(usePartnerConfigStore, ['autoProgress']),
      ...mapState(useLocationStore, ['locations', 'current']),
    },
    methods: {
      handleSelect(location) {
        this.set(location);
        if (this.autoProgress) {
          this.$nextTick(() => this.update());
        }
      },
      ...mapActions(useLocationStore, ['initialize', 'set', 'update'])
    },
    mounted() {
      // Set/reset initial/root locations on mount
      this.initialize();
    },
  }
</script>

<style scoped></style>
